<a href="javascript:void(0)" (click)="onOpenViewDetailModal()">
  <ng-content></ng-content>
</a>

<div
  class="modal fade in"
  id="LosSearchCustomerViewDetailModal{{ index }}"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
>
  <form #f="ngForm" novalidate>
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div
          cdkDragHandle
          class="modal-header"
          style="padding: 2px; border: none"
        >
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            Customer Information
          </h6>
          <button
            type="button"
            (click)="OnClose()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true"
              ><i class="far text-black fa-times-circle"></i
            ></span>
          </button>
        </div>
        <div class="modal-body">
          <div style="overflow: auto">
            <div class="customer-profile-card p-3 mb-3">
              <!-- Top Row: Avatar + Key Identity & Contact -->
              <div class="top-header-section d-flex flex-wrap align-items-center justify-content-between pb-3 mb-3" style="border-bottom: 1px solid #cbd5e1; gap: 1rem;">
                <div class="avatar-identity-row d-flex align-items-center" style="gap: 1rem;">
                  <div class="avatar-container">
                    <img [src]="customerData.ProfilePic ? (customerProfileBaseUrl + customerData.CustomerId + '/' + customerData.ProfilePic) : 'assets/images/default-user.png'" (error)="$event.target.src='assets/images/default-user.png'" alt="Customer Avatar" />
                  </div>
                  <div>
                    <div class="customer-name">{{ customerData.CustomerName || '-' }}</div>
                    <div class="d-flex flex-wrap align-items-center text-muted" style="gap: 0.5rem;">
                      <span class="badge-tag"><i class="fas fa-user-tag mr-1 text-primary"></i><strong>Relation:&nbsp;</strong>{{ customerData.RelationName || '-' }}</span>
                      <span class="badge-tag"><i class="fas fa-venus-mars mr-1 text-info"></i><strong>Gender, Age:&nbsp;</strong>{{ customerData.Gender || '-' }}, {{ customerData.Age || '-' }}</span>
                    </div>
                  </div>
                </div>

                <div class="contact-info-row d-flex flex-wrap align-items-center" style="gap: 1.25rem;">
                  <div class="contact-box">
                    <div class="contact-label">Phone No</div>
                    <div class="contact-val" style="word-break: break-all;">
                      <i class="fas fa-phone-alt mr-1 text-success"></i>
                      <span *ngIf="currentUser.IsMaskingMobile">{{ customerData.PhoneNo | mask }}</span>
                      <span *ngIf="!currentUser.IsMaskingMobile">{{ customerData.PhoneNo || '-' }}</span>
                    </div>
                  </div>
                  <div class="contact-box">
                    <div class="contact-label">Email</div>
                    <div class="contact-val" style="word-break: break-all;"><i class="fas fa-envelope mr-1 text-primary"></i><span *ngIf="currentUser?.IsMaskingMobile">{{ (customerData.Email || '-') | emailmask }}</span><span *ngIf="!currentUser?.IsMaskingMobile">{{ customerData.Email || '-' }}</span></div>
                  </div>
                  <div class="contact-box">
                    <div class="contact-label">Last Update On</div>
                    <div class="contact-val"><i class="far fa-clock mr-1 text-muted"></i>{{ customerData.CreateOn || '-' }}</div>
                  </div>
                </div>
              </div>

              <!-- Bottom Row: Detailed Attributes Grid (CSS Grid) -->
              <div class="customer-profile-grid">
                <div class="grid-item">
                  <div class="item-label">Religion</div>
                  <div class="item-val">{{ customerData.Religion || '-' }}</div>
                </div>
                <div class="grid-item">
                  <div class="item-label">Caste</div>
                  <div class="item-val">{{ customerData.Cast || '-' }}</div>
                </div>
                <div class="grid-item">
                  <div class="item-label">Marital Status</div>
                  <div class="item-val">{{ customerData.MaritalStatus || '-' }}</div>
                </div>
              </div>
            </div>

            <!-- address list -->
            <div class="mt-3 formborder">
              <mat-table
                [dataSource]="dataSourceAddress"
                #SortAddress="matSort"
                matSort
              >
                <ng-container matColumnDef="AddressId">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header mw50"
                    *matHeaderCellDef
                    >#</mat-header-cell
                  >
                  <mat-cell
                    *matCellDef="let row; let i = index"
                    class="grid-cell mw50"
                    style="max-height: 0.3125rem"
                  >
                    {{ i + 1 }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="AddressType">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Address Type</mat-header-cell
                  >
                  <mat-cell
                    *matCellDef="let row"
                    class="grid-cell"
                    (click)="onOpenAddressMapModal(row)"
                    style="
                      color: blue;
                      text-decoration-line: underline;
                      cursor: pointer;
                    "
                  >
                    {{ row.AddressType }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Address">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header mw300"
                    *matHeaderCellDef
                    >Address</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell mw300">{{
                    row.Address
                  }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="LandMark">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header mw200"
                    *matHeaderCellDef
                    >LandMark</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell mw200">{{
                    row.LandMark
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Tehsil_Name">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Tehsil</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.Tehsil_Name
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="District_Name">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >District</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.District_Name
                  }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="PinCode">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header mw100"
                    *matHeaderCellDef
                    >PinCode</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell mw100">{{
                    row.PinCode
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="AddressRentBuy">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header mw150"
                    *matHeaderCellDef
                    >Rent/Own</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell mw150">{{
                    row.AddressRentBuy
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="TotalYearsOnAddress">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >How many years</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.TotalYearsOnAddress
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="IsCommunicationAddress">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Comm. Address</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.IsCommunicationAddress
                  }}</mat-cell>
                </ng-container>

                <mat-header-row
                  *matHeaderRowDef="displayedColumnsAddress"
                ></mat-header-row>
                <mat-row
                  *matRowDef="let row; columns: displayedColumnsAddress"
                ></mat-row>
              </mat-table>
            </div>

            <!-- Categoy list -->
            <div class="mt-3 formborder">
              <mat-table
                [dataSource]="dataSourceCategory"
                #CategorySort="matSort"
                matSort
              >
                <ng-container matColumnDef="CategoyId">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    style="max-width: 3.125rem"
                    *matHeaderCellDef
                  >
                    #
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let row; let i = index"
                    class="grid-cell"
                    style="max-width: 3.125rem; max-height: 0.3125rem"
                  >
                    {{ i + 1 }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Categoy">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Categoy</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.Categoy
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Doc_Name">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Document Type</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">
                    <img
                      src="assets/images/aadhar.jpg"
                      alt=""
                      style="max-width: 3.125rem; margin-right: 0.3125rem"
                      *ngIf="row.Doc_Name == 'Aadhaar Card'"
                    />
                    <img
                      src="assets/images/dl.jpg"
                      alt=""
                      style="max-width: 3.125rem; margin-right: 0.3125rem"
                      *ngIf="row.Doc_Name == 'Driving License'"
                    />
                    <img
                      src="assets/images/electricity.jpg"
                      alt=""
                      style="max-width: 3.125rem; margin-right: 0.3125rem"
                      *ngIf="row.Doc_Name == 'Electricity Bill'"
                    />
                    <img
                      src="assets/images/emp-id-card.jpg"
                      alt=""
                      style="max-width: 3.125rem; margin-right: 0.3125rem"
                      *ngIf="row.Doc_Name == 'Other Photo ID'"
                    />
                    <img
                      src="assets/images/pan-card.jpg"
                      alt=""
                      style="max-width: 3.125rem; margin-right: 0.3125rem"
                      *ngIf="row.Doc_Name == 'PAN Card'"
                    />
                    <img
                      src="assets/images/passport.jpg"
                      alt=""
                      style="max-width: 3.125rem; margin-right: 0.3125rem"
                      *ngIf="row.Doc_Name == 'Passport Copy'"
                    />
                    <img
                      src="assets/images/rasan-card.jpg"
                      alt=""
                      style="max-width: 3.125rem; margin-right: 0.3125rem"
                      *ngIf="row.Doc_Name == 'Ration Card'"
                    />
                    <img
                      src="assets/images/voter-id.jpg"
                      alt=""
                      style="max-width: 3.125rem; margin-right: 0.3125rem"
                      *ngIf="row.Doc_Name == 'Voter ID Card'"
                    />
                    <img
                      src="assets/images/doc.png"
                      alt=""
                      style="max-width: 3.125rem; margin-right: 0.3125rem"
                      *ngIf="
                        row.Doc_Name !== 'Aadhaar Card' &&
                        row.Doc_Name !== 'Driving License' &&
                        row.Doc_Name !== 'Electricity Bill' &&
                        row.Doc_Name !== 'Voter ID Card' &&
                        row.Doc_Name !== 'Ration Card' &&
                        row.Doc_Name !== 'Passport Copy' &&
                        row.Doc_Name !== 'PAN Card' &&
                        row.Doc_Name !== 'Other Photo ID'
                      "
                    />
                    {{ row.Doc_Name }}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="KYC_DocNumber">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Document Number</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">
                    <div *ngIf="currentUser.IsMasking">
                      {{ row.KYC_DocNumber | mask }}
                    </div>
                    <div *ngIf="!currentUser.IsMasking">
                      {{ row.KYC_DocNumber }}
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="UploadOn">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Uploaded On</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.UploadOn
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="EditAction">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    style="max-width: 4.375rem; justify-content: center"
                    *matHeaderCellDef
                  >
                    View
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let row"
                    class="grid-cell"
                    style="max-width: 4.375rem; justify-content: left"
                  >
                    <a
                      href="{{ customerProfileBaseUrl }}{{
                        customerData.CustomerId
                      }}/{{ row.KYC_DocFile }}"
                      class="ml-3"
                      target="_blank"
                      *ngIf="row.Doc_FileName"
                    >
                      <i
                        class="fa fa-eye"
                        style="
                          font-size: medium;
                          cursor: pointer;
                          text-align: center;
                        "
                      ></i>
                    </a>
                    <a
                      href="{{ customerProfileBaseUrl }}{{
                        customerData.CustomerId
                      }}/{{ row.KYC_DocFile1 }}"
                      class="ml-3"
                      target="_blank"
                      *ngIf="row.KYC_DocFile1"
                    >
                      <i
                        class="fa fa-eye"
                        style="
                          font-size: medium;
                          cursor: pointer;
                          text-align: center;
                        "
                      ></i>
                    </a>
                  </mat-cell>
                </ng-container>

                <mat-header-row
                  *matHeaderRowDef="displayedColumnsCategory"
                ></mat-header-row>
                <mat-row
                  *matRowDef="let row; columns: displayedColumnsCategory"
                ></mat-row>
              </mat-table>
            </div>

            <!-- application list -->
            <div class="mt-3 formborder">
              <mat-table
                [dataSource]="dataSourceApplication"
                #ApplicationSort="matSort"
                matSort
              >
                <ng-container matColumnDef="ApplicationId">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    style="max-width: 3.125rem"
                    *matHeaderCellDef
                  >
                    #
                  </mat-header-cell>
                  <mat-cell
                    *matCellDef="let row; let i = index"
                    class="grid-cell"
                    style="max-width: 3.125rem; max-height: 0.3125rem"
                  >
                    {{ i + 1 }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ApplicationNo">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Application No</mat-header-cell
                  >
                  <!-- <mat-cell *matCellDef="let row" class="grid-cell" (click)="onOpenApplicationMapModal(row)"
      style="color: blue; text-decoration-line: underline; cursor: pointer;">
      {{ row.ApplicationNo }}
    </mat-cell> -->
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.ApplicationNo
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="LoanAcNo">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Loan A/C No.
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.LoanAcNo
                  }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Total_OverDUE_EMI_Amount">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >OverDUE EMI Amount
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.Total_OverDUE_EMI_Amount
                  }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Balance_Principle">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Principal</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.Balance_Principle
                  }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="CustomerType">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Customer Type</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">
                    {{
                      row.CustomerType == "Hirer"
                        ? "Borrower"
                        : row.CustomerType
                    }}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Product">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Product</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.Product
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Branch">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Branch</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.Branch
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="LoanAmount">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Amount</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">
                    {{
                      row.LoanAmount > 0 ? "₹" + row.LoanAmount : ""
                    }}</mat-cell
                  >
                </ng-container>

                <ng-container matColumnDef="CreateOn">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Application Create On</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.CreateOn
                  }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Application_Status">
                  <mat-header-cell
                    mat-sort-header
                    class="grid-header"
                    *matHeaderCellDef
                    >Status</mat-header-cell
                  >
                  <mat-cell *matCellDef="let row" class="grid-cell"
                    >{{ row.Application_Type }}-{{
                      row.LoanAcNo != "" &&
                      row.LoanAcNo != null &&
                      row.Status == "Completed"
                        ? "Live"
                        : row.Status
                    }}</mat-cell
                  >
                </ng-container>

                <mat-header-row
                  *matHeaderRowDef="displayedColumnsApplication"
                ></mat-header-row>
                <mat-row
                  *matRowDef="let row; columns: displayedColumnsApplication"
                ></mat-row>
              </mat-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div
  class="modal fade in"
  id="LosSearchCustomerViewMapModal{{ index }}"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
>
  <form #f="ngForm" novalidate>
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 0.3125rem">
          <p class="modal-title" id="myModalLabel" name="myModalLabel">
            Address: {{ ShowMapAddress }}
          </p>
          <button
            type="button"
            (click)="onCloseAddressMapModal()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true"
              ><i class="far text-black fa-times-circle"></i
            ></span>
          </button>
        </div>
        <div class="modal-body">
          <div id="map" style="border: 2px solid #3872ac">
            <google-map
              [center]="{lat: lat, lng: lng}"
              [zoom]="zoom"
              [options]="{disableDefaultUI: true, zoomControl: true}"
            >
              <map-marker [position]="{lat: lat, lng: lng}"> </map-marker>
            </google-map>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
